/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{getProjector as r,copy3 as t}from"./projectors.js";function o(o,n,e,f,l,u,c=Math.floor(o.length/3)){const i=r(n,l);if(null==i)return!1;if(i===t){if(o===f&&e===u)return!0;const r=e+3*c;for(let t=e,n=u;t<r;t++,n++)f[n]=o[t];return!0}const s=e+3*c;for(let r=e,t=u;r<s;r+=3,t+=3)i(o,r,f,t);return!0}export{o as projectBuffer};
